export const datePickerConfig = {
  format: 'YYYY-MM-DD',
  keepInvalid: true,
  maxDate: new Date(),
  minDate: new Date('1850-01-01'),
  locale: 'hu',
  useStrict: true,
  showTodayButton: false,
  icons: {
    time: 'fa fa-clock',
    date: 'fa fa-calendar',
    up: 'fa fa-arrow-up',
    down: 'fa fa-arrow-down',
    previous: 'fa fa-chevron-left',
    next: 'fa fa-chevron-right',
    today: 'fa fa-calendar-check-o',
    clear: 'fa fa-trash-alt',
    close: 'fa fa-times-circle'
  }
}